import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TablaServiciosSeguimientoJefeProyectos from "../components/seguimiento/TablaServiciosSeguimientoJefeProyectos";
import TablaServiciosSeguimientoMarcas from "../components/seguimiento/TablaServicioSeguimientoMarcas"
import ChartPricesSeguimientoJefeProyectos from "../components/seguimiento/ChartPricesSeguimientoJefeProyectos";
import TablaServiciosSubareas from "../components/seguimiento/TablaServiciosSubareas";
import axios from "axios";
import { BACKEND } from "../config/configEnvs";
import { FaChevronLeft, FaChevronRight, FaClipboardList, FaSearch, FaSpinner, FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';


const Seguimiento = () => {
  const user = useSelector((state) => state.auth.user);

  const [loadingStatus, setLoadingStatus] = useState(true) // Estado de carga

  const [clientesList, setClientesList] = useState([]); // Lista de clientes

  const [activeFilter, setActiveFilter] = useState(false) // Filtro activo e inactivo

  const [searchText, setSearchText] = useState("") // Texto de la barra de búsqueda

  // Metadatos
  const [limit, setLimit] = useState(30)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalDocs, setTotalDocs] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [currentdocs, setCurrentDocs] = useState(0)

  const handleSearchClients = () => { // Funcion para buscar clientes, automáticamente lleva a la página 1
    fetchBrands()
    setCurrentPage(1)
  }

  const handleResetSearch = () => { // Resetea la búsqueda
    setSearchText(""); // Cambiar el estado
  };

  const handlePageChange = (page) => { // Cambia de página
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  
  const fetchBrands = async () => { // Trae los servicios del usuario en caso no sea admin, y trae todos los servicios en caso sí sea admin. El filtrado se procesa en el backend.
      try {
        setLoadingStatus(true)
        let url = `${BACKEND}/api/userProcessesInterface/getBrands?userId=${user.id}&page=${currentPage}&limit=${limit}&activeFilter=${activeFilter}`;
  
        if (searchText) {
          url += `&brandName=${encodeURIComponent(searchText)}`
        }
  
        const response = await axios.get(url);
  
        setClientesList(response.data.brands)
        setTotalDocs(response.data.pagination.totalDocs)
        setCurrentDocs(response.data.brands.length)
        setTotalPages(response.data.pagination.totalPages)
  
      } catch (error) {
        toast.error("Error obteniendo los clientes: " + error)
      } finally {
        setLoadingStatus(false)
      }
  };

  useEffect(() => { // Cada que cambia de pagina se verifica
    fetchBrands()
  }, [currentPage, limit, activeFilter])

  useEffect(() => { // Solo se ejecuta cuando se vacea la barra de búsqueda
    if (searchText === "") {
      fetchBrands(); // Solo se ejecuta cuando se reinicia la búsqueda
      setCurrentPage(1); // Reiniciar la paginación si es necesario
    }
  }, [searchText]);

  const activeFilterHandler = () => {
    setActiveFilter(prevState => !prevState);
  }

  return (
    <div className="h-screen">

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 overflow-x-auto bg-gray-100 mb-2">
        <div className="flex flex-row w-full items-center gap-4 justify-between">
          
          <div className="flex items-center gap-4 py-4">
            <FaClipboardList className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Seguimiento de proyectos</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">
           
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Límite:</span>
              <select
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
                className="text-gray-700 text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
              </select>
            </div>

            <div className="relative w-full">
              <input
                type="text"
                placeholder="Buscar marca"
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
              {searchText && (
                <FaTimes
                  onClick={() => handleResetSearch()}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>

            <div>
              <Button 
                variant="contained"
                endIcon={<SearchIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => handleSearchClients()}
              >
                Buscar
              </Button>
            </div>

          </div>

        </div>
      </div>

      {/* MidBar */}
      <div className="flex items-center justify-center bg-gray-100 gap-3 mb-2 py-2 px-4 rounded-sm">
        <span className="text-gray-700 text-xs font-medium">Mostrar solo las marcas con servicios activos o por comenzar</span>
        <label className="relative inline-flex items-center cursor-pointer">
          <input
              id="activeFilter"
              type="checkbox"
              checked={activeFilter}
              onChange={activeFilterHandler}
              className="sr-only peer"
          />
          <div className="w-11 h-6 bg-gray-200 rounded-full peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 peer-dark:bg-gray-700 peer-checked:bg-blue-600 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all dark:border-gray-600"></div>
        </label>
      </div>

      {loadingStatus ? (
        <div className="flex flex-row justify-center items-center h-[69vh] gap-4 border-b">
          <FaSpinner className="animate-spin text-gray-500" />
          <span className="text-gray-600">Cargando, por favor espera...</span>
        </div>
      ) : (
        <TablaServiciosSeguimientoMarcas
          clients={clientesList?.filter(
            (client) => client !== null && client !== undefined
          )}
          userRedux={user}
        />
      )}

      {/* Paginador */}
      <nav aria-label="Page navigation example" className="flex justify-center mt-4">
          <ul className="flex items-center -space-x-px h-10 text-base">
              <li>
                  <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      className={`flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed ${currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''}`}
                  >
                      <FaChevronLeft />
                  </button>
              </li>

              {[...Array(totalPages).keys()].filter(page => Math.abs(page + 1 - currentPage) <= 2 || page === 0 || page === totalPages - 1).map(page => (
                  <li key={page + 1}>
                      <button
                        onClick={() => handlePageChange(page + 1)}
                        className={`flex items-center justify-center px-4 h-10 leading-tight ${
                            currentPage === page + 1
                            ? "text-white border-blue-300 bg-blue-600 hover:bg-blue-700"
                            : "text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700"
                        }`}
                      >
                        {page + 1}
                      </button>
                  </li>
              ))}

              <li>
                  <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      className={`flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700 ${currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : ''}`}
                  >
                      <FaChevronRight />
                  </button>
              </li>

          </ul>
      </nav>

      <div className="flex justify-center mt-4">
          <span className="text-sm text-gray-700 dark:text-gray-500">
              Mostrando
              <span className="font-semibold text-gray-900 dark:text-gray-300 ">
                  {" "}
                  {currentdocs}
              </span>{" "}
              de
              <span className="font-semibold text-gray-900 dark:text-gray-300 ">
                  {" "}
                  {totalDocs}
              </span>{" "}
              Marcas
          </span>
      </div>

    </div>
  );
};

export default Seguimiento;
